import React, { useState } from 'react';
import KPITable from './components/KPITable';
import KPITools from './components/KPITools';
import KPIFormModel from './components/KPIFormModel';

const initialState = {
  isModal: { model: false, submit: false },
  modalHeader: { title: '', isEdit: false, editId: '' },
  editKPIData: {},
  search: '',
  isDelete: { id: '', status: '' },
  selectEmployeeData: [],
  selectDesignationData: [],
  selectGender: [],
  selectMaritalStatus: [],
  selectDepartmentData: [],
  currentPage: 1,
  rowsPerPage: 10,
  isNext: false,
  sortField: 'createdAt',
  sortDirection: false,
  loading: false,
  dropdownDataStore: [],
  currentPageDropdown: 1,
  rowsPerPageDropdown: 10,
  dropdownDesignationData: [],
  dropdownDepartmentData: [],
  currentPageDesignationDropdown: 1,
  rowsPerPageDropdownDesignation: 10,
  currentPageDepartmentDropdown: 1,
  rowsPerPageDropdownDepartment: 10
};

const KPIList = () => {
  const [state, setState] = useState(initialState);

  return (
    <div className="container-xxl">
      <KPITools state={state} setState={setState} />

      {state?.isModal?.model && <KPIFormModel state={state} setState={setState} />}
      <KPITable state={state} setState={setState} />
    </div>
  );
};

export default KPIList;
